module.exports = __webpack_public_path__ + "img/lang-en.82870027.svg";